import { Box } from '@chakra-ui/react';
import { SkipNavContent, SkipNavLink } from '@chakra-ui/skip-nav';
import styled from '@emotion/styled';
import { ErrorBoundary, ErrorFallback } from 'components/error-fallback';
import { MobileSubNav } from 'components/Sidebar/sidebar.sm';
import { APP_ROUTES } from 'constants/app-constants';
import usePageTracking from 'hooks/usePageTracking';
import useUpdateDocTitle from 'hooks/useUpdateDocTitle';
import React from 'react';

import AppHeaderSm from './app-header.sm';

const App = styled(Box)(() => ({ height: '100vh' }));
const AppBody = styled(Box)(() => ({ height: '100%', overflow: 'auto' }));
const AppContent = styled(Box)(() => ({ height: 'calc(100% - 3rem)', overflow: 'auto' }));

const fallBack = (props: any) => <ErrorFallback {...props} />;

export const AppLayoutSm = (props: { children: React.ReactNode }) => {
  usePageTracking();
  useUpdateDocTitle(APP_ROUTES);

  return (
    <>
      <SkipNavLink zIndex={9999}>Skip to content</SkipNavLink>

      <App>
        <ErrorBoundary fallback={fallBack}>
          <Box>
            <MobileSubNav initialDrawerOpen={false} />
          </Box>
          <AppBody px={4} w="100%">
            <SkipNavContent />
            <AppHeaderSm />
            <AppContent>{props.children}</AppContent>
          </AppBody>
        </ErrorBoundary>
      </App>
    </>
  );
};

export default AppLayoutSm;
